import { render, staticRenderFns } from "./ClientClaimSave.vue?vue&type=template&id=4306e6fc&scoped=true&"
import script from "./ClientClaimSave.vue?vue&type=script&lang=ts&"
export * from "./ClientClaimSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4306e6fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4306e6fc')) {
      api.createRecord('4306e6fc', component.options)
    } else {
      api.reload('4306e6fc', component.options)
    }
    module.hot.accept("./ClientClaimSave.vue?vue&type=template&id=4306e6fc&scoped=true&", function () {
      api.rerender('4306e6fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/clientConfiguration/clientClaim/ClientClaimSave.vue"
export default component.exports